import React, { lazy, Suspense, useEffect } from "react";
import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import { Layout, LayoutSplashScreen } from "../martin/_layout";
import Home from "./modules/Common/Home";
import Uix from "./modules/Common/Uix";
import Apps from "./modules/Common/Apps";
import Contact from "./modules/Common/Contact";
import Account from "./modules/Common/Account";
import Snippets from "./modules/Common/Snippets";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as commonActions from "./redux/commonActions";
import ErrorsPage from "./modules/Error/ErrorsPage";

const AuthPage = lazy(() => import("./modules/Auth/AuthPage"));
const ViewApp = lazy(() => import("./modules/Common/ViewApp"));
const Privacy = lazy(() => import("./modules/Common/Privacy"));
const Search = lazy(() => import("./modules/Common/Search"));

export default function BasePage() {
  const dispatch = useDispatch();
  const { token, isAuthorized } = useSelector(
    ({ auth }) => ({
      isAuthorized: auth.user != null && auth.authToken != null,
      token: auth.authToken,
    }),
    shallowEqual
  );
  useEffect(() => {
    dispatch(commonActions.checkToken({ jwt: token }));
    dispatch(commonActions.fetchSettings());
    dispatch(commonActions.fetchCategories());
  }, [dispatch, token]);

  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Routes>
        <Route path="/" element={<Outlet />}>
          <Route element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="account/:hex/:action" element={<Account />} />
            <Route path="uix" exact={true} element={<Uix />} />
            <Route path="apps" exact={true} element={<Apps />} />
            <Route path="apps/:slug" exact={true} element={<ViewApp />} />
            <Route path="snippets" exact={true} element={<Snippets />} />
            <Route path="hello" exact={true} element={<Contact />} />
            <Route path="privacy" exact={true} element={<Privacy />} />
            <Route path="search" exact={true} element={<Search />} />
            <Route path="search/:query" exact={true} element={<Search />} />
            {!isAuthorized && <Route path="auth" element={<Navigate to="/" replace />} />}
            {isAuthorized && <Route path="auth/:page" element={AuthPage} />}
            <Route path="index.html" element={<Navigate to="/" replace />} />
          </Route>
          <Route element={<Outlet />}>
            <Route path="error/:type" element={<ErrorsPage />} />
            <Route path="error" element={<Navigate to="error/500" />} />
            {/* <Route path="*" element={<Navigate to="error/404" replace />} /> */}
          </Route>
        </Route>
      </Routes>
    </Suspense>
  );
}
